import { setContentWidth, resetContentWidth, } from "../../utils/index.js"
import './index.less'

const Modal = (function () {
    let instance;
    let isOpen = false;
    let ms = ''
    let _params = {}
    let ids = {} // 缓存content header等


    function createModal(message, params = {}) {
        ms = message
        _params = params
        !ids[params.id] && (ids[params.id] = {
            header: params.header ? params.header : '',
            message: message,
            class: params.class ? params.class : ''
        })

        // 创建模态框 DOM 结构
        const modal = document.createElement('div');
        modal.classList.add('new-modal');
        modal.classList.add('new-modal-container');
        const modalContent = document.createElement('div');
        modalContent.classList.add('new-modal-content');
        const closeBtn = document.createElement('span');
        closeBtn.classList.add('close');
        closeBtn.innerHTML = `<svg width="34" height="34" style="top: 12px;right: 6px;" class="new-modal__close svelte-1g8kkze" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.658548 32.8346C0.944174 33.1197 1.2802 33.3126 1.66664 33.4133C2.05308 33.5139 2.44371 33.5139 2.83855 33.4133C3.23338 33.3126 3.57362 33.1197 3.85924 32.8346L16.7628 19.9272L29.6916 32.8346C29.9772 33.1197 30.3133 33.3126 30.6997 33.4133C31.0862 33.5139 31.4726 33.5139 31.859 33.4133C32.2455 33.3126 32.5815 33.1197 32.8671 32.8346C33.1695 32.5494 33.367 32.2098 33.4594 31.8156C33.5518 31.4214 33.5518 31.0314 33.4594 30.6456C33.367 30.2598 33.1695 29.9243 32.8671 29.6392L19.9635 16.7318L32.8671 3.84957C33.1695 3.56442 33.367 3.22894 33.4594 2.84315C33.5518 2.45735 33.5518 2.06736 33.4594 1.67318C33.367 1.279 33.1695 0.939329 32.8671 0.654175C32.5815 0.369022 32.2455 0.176124 31.859 0.0754818C31.4726 -0.0251606 31.0862 -0.0251606 30.6997 0.0754818C30.3133 0.176124 29.9772 0.369022 29.6916 0.654175L16.7628 13.5616L3.85924 0.654175C3.57362 0.369022 3.23338 0.176124 2.83855 0.0754818C2.44371 -0.0251606 2.05308 -0.0251606 1.66664 0.0754818C1.2802 0.176124 0.944174 0.369022 0.658548 0.654175C0.35612 0.939329 0.158702 1.279 0.0662931 1.67318C-0.0261155 2.06736 -0.0219151 2.45735 0.0788942 2.84315C0.179704 3.22894 0.372921 3.56442 0.658548 3.84957L13.5873 16.7318L0.658548 29.6392C0.372921 29.9243 0.179704 30.2598 0.0788942 30.6456C-0.0219151 31.0314 -0.0261155 31.4214 0.0662931 31.8156C0.158702 32.2098 0.35612 32.5494 0.658548 32.8346Z" fill="white"/>
</svg>`;

        const messageEl = document.createElement('div');
        messageEl.classList.add('new-modal-content-body');
        // messageEl.textContent = message;
        if(message instanceof HTMLElement) {
            messageEl.appendChild(message)
        }
        if(typeof message === 'string') {
            messageEl.innerHTML = message
        }

        // const confirmBtn = document.createElement('div');
        // confirmBtn.classList.add('modal-content-');

        const modalHeader = document.createElement('div');
        const modalHeaderContent = document.createElement('div');
        modalHeaderContent.classList.add('new-moadal-header-content');
        modalHeaderContent.textContent = _params.header ? _params.header : ''
        modalHeader.classList.add('new-moadal-header');
        modalHeader.appendChild(modalHeaderContent);
        modalHeader.appendChild(closeBtn);

        modalContent.appendChild(modalHeader);
        // modalContent.appendChild(closeBtn);
        modalContent.appendChild(messageEl);
        // modalContent.appendChild(confirmBtn);

        modal.appendChild(modalContent);

        // 添加事件监听器
        closeBtn.addEventListener('click', function () {
            closeModal();
        });

        // confirmBtn.addEventListener('click', function () {
        //     closeModal();
        //     if (params.cb && typeof params.cb === 'function') {
        //         params.cb();
        //     }
        // });

        // 添加到文档中
        document.body.appendChild(modal);

        // 显示模态框
        modal.classList.add('fade-in');
        isOpen = true;
        // 禁止body滚动
        setContentWidth()

        if (params.cb && typeof params.cb === 'function') {
            params.cb(modal);
        }

        function closeModal() {
            const videos = modal.querySelectorAll('video, jky-video');
            videos.forEach(function (video) {
                if (video) {
                    video.pause();
                    video.muted = true;
                }
            });
            modal.classList.add('fade-out');
            modal.classList.remove('fade-in');
            modal.querySelector('.new-modal-content').classList.remove('fade-in');
            setTimeout(function () {
                modal.style.display = 'none';
                modal.classList.remove('fade-out');
                modal.querySelector('.new-modal-content').classList.remove('fade-out');
                isOpen = false;
                // 恢复body滚动
                resetContentWidth()
            }, 300);
        }
        // 按下 ESC 键关闭模态框
        document.addEventListener('keydown', function (e) {
            if (isOpen && e.keyCode === 27) {
                closeModal();
            }
        });

        // 点击模态框外部区域关闭模态框
        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                closeModal();
            }
        });

        // 新调用更像content
        function updateMessage(newMessage) {
            ms = newMessage
            if(newMessage instanceof HTMLElement) {
                messageEl.innerHTML = ''
                messageEl.appendChild(newMessage)
            }
            if(typeof newMessage === 'string') {
                messageEl.innerHTML = newMessage
            }
        }

        function updateHeader(newMessage) {
            _params.header = newMessage || ''
            modalHeaderContent.innerHTML = newMessage;
        }

        function updateClass(newClass) {
            newClass = newClass ? newClass : 'no-class'
            modal.classList.remove(...modal.classList)
            modal.classList.add(newClass, 'fade-in', 'new-modal-container', 'new-modal');

            setTimeout(() => {
                modal.querySelector('.new-modal-content').classList.add('fade-in');
            }, 20);
        }

        function openModal(params) {
            updateClass(params.class)
            modal.style.display = 'flex';
            isOpen = true;

            setTimeout(() => {
                modal.querySelector('.new-modal-content').classList.add('fade-in');
            }, 20);

            // 禁止body滚动
            setContentWidth()

            if (params.cb && typeof params.cb === 'function') {
                params.cb(modal);
            }
        }

        return {
            closeModal,
            openModal,
            updateMessage,
            updateHeader,
            updateClass
        };
    }

    return {
        getInstance: function (message, params = {}) {
            if (!instance) {
                instance = createModal(message, params);
                instance.updateClass(params.class)
            } else {
                !ids[params.id] && (ids[params.id] = {
                    header: params.header ? params.header : '',
                    message: message,
                    class: params.class ? params.class : ''
                })
                if (ids[params.id]) {
                    instance.updateMessage(ids[params.id].message)
                    instance.updateHeader(ids[params.id].header)
                } else {
                    if (ms !== message) {
                        instance.updateMessage(message)
                    }
                    if (params.header !== _params.header) {
                        instance.updateHeader(params.header)
                    }
                }
                instance.openModal(params)
            }
            return instance;
        },
        updateInstance: function (message, params = {}) {
            if (!instance) {
                instance = createModal(message, params);
                instance.updateClass(params.class)
            } else {
                instance.updateMessage(message);
                instance.updateHeader(params.header || '');
                instance.updateClass(params.class);
            }
            instance.openModal(params)

            return instance;
        }
    };
})();

export default Modal
